export {
  Testimonials,
  TestimonialsPsihologiyaIsHigherEducation
} from './Testimonials'
